import { createSelector } from 'reselect';
import { getFormValues, isPristine } from 'redux-form';
import { CUSTOMER_INFO_FORM } from './Actions';
import { isPresent } from 'utils/isPresent';

const MINIMUM_NUMBER_OF_FORM_FIELDS_FILLED = 2;

export const isCustomerInfoFormFilled = createSelector(
  (state) => getFormValues(CUSTOMER_INFO_FORM)(state),
  (state) => isPristine(CUSTOMER_INFO_FORM)(state),
  (formValues, isFormPristine) =>
    !isFormPristine
    && isPresent(formValues)
    && Object.keys(formValues).length > MINIMUM_NUMBER_OF_FORM_FIELDS_FILLED,
);
